import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const de: DeepPartial<Messages> = {
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> ergebnisse',
  nextQueriesSuggestions: {
    title: 'Wer nach {query} suchte, suchte ebenfalls nach...'
  },
  search: {

    inputPlaceholderAlternativesHTML: ['Was suchen Sie?']
  },
  facets: {
    clearFilters: 'Filter löschen',

    toggle: {
      groups: {
        'all-facets': {
          outside: {
            openHTML: '({selectedFiltersCount}) Filter anzeigen',
            closeHTML: 'Filter ausblenden'
          }
        }

      }

    }
  },
  nextQueries: {
    titleHTML: ''
  },
  history: {
    disable: 'off',
    enable: 'on'
  },
  results: {
    addToCart: 'In den Warenkorb legen'
  }
};
